import { Controller } from '@hotwired/stimulus';

// Drives the BD landing libraire-of-the-month slider. All cards are rendered
// server-side (card targets, ordered current-first). This controller shows one
// at a time and wires the prev/next arrows. prev() goes back in time (older),
// next() goes forward (newer); index 0 is the current month.
export default class extends Controller {
  static targets = ['card', 'prev', 'next', 'counterMonth', 'counterStatus'];

  static values = {
    index: { type: Number, default: 0 },
    total: { type: Number, default: 0 }
  };

  connect() {
    this.render();
  }

  prev() {
    if (this.indexValue < this.totalValue - 1) {
      this.indexValue += 1;
      this.render();
    }
  }

  next() {
    if (this.indexValue > 0) {
      this.indexValue -= 1;
      this.render();
    }
  }

  render() {
    const current = this.cardTargets[this.indexValue];
    if (!current) return;

    // Fade the visible card, swap, then fade back in — mirrors the mockup.
    const visible = this.cardTargets.find((c) => !c.hidden);
    if (visible && visible !== current) {
      visible.classList.add('is-changing');
    }

    setTimeout(() => {
      this.cardTargets.forEach((card, i) => {
        card.hidden = i !== this.indexValue;
        card.classList.remove('is-changing');
      });
      this.updateNav(current);
    }, visible && visible !== current ? 200 : 0);
  }

  updateNav(card) {
    if (this.hasPrevTarget) {
      this.prevTarget.disabled = this.indexValue >= this.totalValue - 1;
    }
    if (this.hasNextTarget) {
      this.nextTarget.disabled = this.indexValue <= 0;
    }

    if (this.hasCounterMonthTarget) {
      this.counterMonthTarget.textContent = card.dataset.month || '';
    }
    if (this.hasCounterStatusTarget) {
      this.counterStatusTarget.textContent = this.statusLabel(card);
    }
  }

  statusLabel(card) {
    if (card.dataset.current === 'true') {
      return 'mois en cours';
    }
    const n = this.indexValue;
    return n === 1 ? 'le mois dernier' : n + ' mois auparavant';
  }
}
